export const DATADOG_SITE =
  process.env.NEXT_PUBLIC_DATADOG_SITE || 'datadoghq.com';
export const DATADOG_SERVICE =
  process.env.NEXT_PUBLIC_DATADOG_SERVICE || 'birch';
export const DATADOG_VERSION =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || '1.0.0';
export const DATADOG_ENV =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    ? 'production'
    : process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
      ? 'staging'
      : 'local';
